<template>
  <div class="database section-main__warp">
    <!-- start @description: 过滤条件区-分割线 !-->
    <!-- <div class="sparate-line mb20"></div> -->

    <!-- start @description: 表格 !-->
    <div class="table">
      <ioc-table :option="tableOption"
                 ref="table"
                 :data="databaseData "
                 @search-change="handleSearchChange"
                 @search-reset="handleSearchReset"
                 @current-change="handleCurrentChange"
                 @size-change="handleSizeChange"
                 :page="page">
        <!-- 顶部按钮 左侧自定义 -->
        <!-- 新增 仅显示我指派 -->
        <template slot="menuLeft">
          <el-button type="primary"
                     @click="add"
                     v-auth="'/databaseBackup:add'"
                     class="btn-style">
            新增
          </el-button>
        </template>
        <!-- 表格列 自定义 -->
        <template slot="backupTimeTable"
                  slot-scope="scope">
          <span>{{scope.row.beginTime}}-{{scope.row.endTime}}</span>
        </template>
        <template slot="menu"
                  slot-scope="scope">
          <div class="pl10">

            <!-- 下载 -->
            <el-tooltip class="item"
                        effect="dark"
                        content="下载备份文件"
                        placement="top"
                        popper-class="tooltip-draw">
              <a :href="scope.row.dataFile"
                 style="padding:0 9px">
                <el-button type="text"
                           @click="download(scope.row)"
                           icon="el-icon-download"></el-button>
              </a>
            </el-tooltip>
            <!--日志· -->
            <el-tooltip class="item"
                        effect="dark"
                        content="下载日志"
                        placement="top"
                        popper-class="tooltip-draw">
              <el-button type="text"
                         @click="readLog(scope.row)"
                         icon="el-icon-download"></el-button>
            </el-tooltip>
            <!-- 详情-->
            <el-tooltip class="item"
                        effect="dark"
                        content="详情"
                        placement="top"
                        popper-class="tooltip-draw">
              <el-button type="text"
                         @click="detail(scope.row)"
                         icon="iconfont icon-Detail"></el-button>
            </el-tooltip>
            <!-- 删除 -->
            <el-tooltip class="item"
                        effect="dark"
                        content="删除"
                        placement="top"
                        popper-class="tooltip-draw">
              <el-button type="text"
                 v-auth="'/databaseBackup:delete'"
                         @click="deleteRow(scope.row)"
                         icon="iconfont icon-shanchu"></el-button>
            </el-tooltip>

          </div>
        </template>
      </ioc-table>
    </div>
    <el-dialog title="新增备份"
               v-dialogDrag
               :visible.sync="dialogVisible"
               width="500px">
      <div class="contain">
        <el-form label-width="120px"
                 ref="form"
                 label-position="left"
                 :model="formData"
                 :rules="rules">
          <el-form-item label="数据备份名称"
                        prop="backupName">
            <el-input style="width:75%"
                      v-model="formData.backupName"></el-input>
          </el-form-item>
          <el-form-item label="备份类型"
                        prop="type">
            <el-select style="width:75%"
                       v-model="formData.type">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="dialog-footer">
          <el-button type="primary"
                     class="footer-btn"
                     @click="confirm">确定</el-button>
          <el-button @click="cancel"
                     class="footer-btn">取消</el-button>
        </div>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import { api } from '../api/api'
import { Dates, Dic } from '$utils'
import { table } from '../options/table'
import store from '@src/common/lib/store'
import i18n from '@src/common/lib/i18n'
import dayjs from 'dayjs'
import utils from '@src/common/utils'
export default {
  components: {

  },
  data () {
    return {

      searchParams: {
        backupName: '',
        type: '',
        backupTime: ''

      },
      //新增
      formData: {
        backupName: '',
        type: '',
      },
      //备份名称
      backupName: '',
      beginTime: '',
      endTime: '',
      type: '',
      //备份类型
      options: Dic.find('SENU107001'),
      dialogVisible: false,
      page: {
        // 当前页
        currentPage: 1,
        // 查询记过总计
        total: 0,
        // 每页默认显示条数
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      },
      databaseData: [],
      tableOption: table(this),
      defaultFinishTime: '',
      defaultStartTime: '',
      //多选中的数据code数据
      backupCodeList: [],
      rules: {
        backupName: [{ required: true, message: '请输入备份名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择备份类型', trigger: 'change' }]
      }
    }
  },
  created () {
    this.getList()

  },
  mounted () {

  },
  methods: {

    getList () {
      const params = {
        backupName: this.searchParams.backupName,
        beginTime: this.beginTime,
        endTime: this.endTime,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        status: "",
        type: this.searchParams.type
      }
      let url = api.queryDatabaseBackupList
      // 建议均使用配置的aixos请求，axios里面配置过了基本的请求方式能满足全局使用，除非特殊情况，需自定义请求方式
      this.$fetch(url, params).then(res => {
        if (res.success) {

          this.databaseData = res.returnObj.list
          this.page.total = Object.freeze(res.returnObj.total)
        } else {
          this.$message({
            message: res.msgContent,
            type: 'error',
          })
        }
      })

    },
    //搜索
    handleSearchChange (param) {
      this.searchParams = param;
      if (param.backupTime) {
        this.beginTime = Dates.format(param.backupTime[0], 'yyyy-MM-dd HH:mm:ss')
        this.endTime = Dates.format(param.backupTime[1], 'yyyy-MM-dd HH:mm:ss')
      }
      this.page.currentPage = 1;
      this.getList();
    },
    //重置搜索
    handleSearchReset () {
      this.searchParams.backupName = '';
      this.searchParams.backupTime = '';
      this.searchParams.type = '';
      // this.searchParams.beginTime = '';
      // this.searchParams.endTime = '';
      this.beginTime = "";
      this.endTime = ""
      this.page = {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
      };
      this.getList();
    },
    add () {
      this.dialogVisible = true;
      this.formData = {}

    },
    //新增提交
    confirm () {
      this.$refs["form"].validate((res) => {
        if (res) {
          this.addDatabaseBackup()
          this.dialogVisible = false
        }
      })

    },
    cancel () {
      this.searchParams.backupName = '';
      this.searchParams.type = '';
      this.searchParams.beginTime = '';
      this.searchParams.endTime = '';
      this.dialogVisible = false
    },

    //新增
    addDatabaseBackup () {
      const params = {
        backupName: this.formData.backupName,
        type: this.formData.type + ''
      }
      let url = api.addDatabaseBackup
      this.$fetch(url, params).then((res) => {
        if (res.success) {
          this.$message({
            showClose: false,
            message: "备份成功",
            type: 'success',

          })
          this.page.total = Object.freeze(res.returnObj.total)
          this.dialogVisible = true
          this.getList()
        } else {
          this.$message({
            message: res.msgContent,
            type: 'error',
          })
        }
      })
    },
    download (data) {
      console.log(data.dataFile)


    },
    readLog (data) {
      this.$fetchDownLoad(data.logFile, {}, { responseType: 'arraybuffer' }).then((response) => {
        const content = response.data
        const blob = new Blob([content], { type: 'application/zip' })
        const fileName = data.backupName + Dates.format(Date.now(), 'yyyyMMddHHmmssms') + '.zip'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
        // this.option.exportDisabled = false
      })

    },
    detail (data) {
      this.$refs.table.rowView(data)

    },
    // selectionChange (data) {
    //   this.backupCodeList=data.map(el=>{
    //     return el.backupCode
    //   })
    // },
    // 删除触发
    deleteRow (data) {
      let backupCodeList = []
      backupCodeList.push(data.backupCode)
      // console.log(data, '====================data')
      this.$confirm(this.$t('taskCenter.message.deleteWarn'), this.$t('taskCenter.button.prompt'), {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: 'warning',
      })
        .then(() => {
          const params = {
            backupCodeList: backupCodeList,
            forceFlag: data.forceFlag
          }
          this.$fetch(api.deleteDatabaseBackup, params).then((res) => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: "删除成功",
              })
              this.getList()
            } else {
              this.$message({
                type: 'error',
                message: res.msgContent,
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('taskCenter.message.cancelDel'),
          })
        })
    },

    //获取当前时间
    getDefaultTime () {
      let currentDate = new Date()
      this.defaultFinishTime = this.taskInfo.finishTime = Dates.format(currentDate, 'yyyy-MM-dd')
      this.defaultStartTime = this.taskInfo.startTime = Dates.format(currentDate.setDate(currentDate.getDate() - 6), 'yyyy-MM-dd')
    },
    // 筛选时间
    filterTime () {
      let finishTime = Date.parse(this.taskInfo.finishTime)
      let startTime = Date.parse(this.taskInfo.startTime)
      // 根据查询条件
      if (startTime > finishTime) {
        this.$message.error(this.$t('taskCenter.message.timeMore'))
      }
      this.taskInfo.finishTime = Dates.format(finishTime, 'yyyy-MM-dd')
      this.taskInfo.startTime = Dates.format(startTime, 'yyyy-MM-dd')
    },

    clearCondition () {

    },


    // 分页 页面跳转
    handleCurrentChange (val) {
      this.page.currentPage = val

    },
    // 分页 每页显示行数
    handleSizeChange (val) {
      this.page.currentPage = 1
      this.page.pageSize = val

    },
  },
}
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.table {
  width: 100%;
}
.database {
  .dialog-footer {
    margin-top: 50px;
    width: 100%;
    //padding-right: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
